import { IData } from '../fetchProvenances'
import { IProvenance } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): IProvenance => ({
      id: Number(item.id),
      idUser: Number(item.id_user),
      isDeleted: Boolean(Number(item.deleted)),
      name: item.name,
    }),
  )
}
